import * as React from "react";
import { Card, CardContent } from "@mui/material";

function NewCard({ title, content, sx }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <Card
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        borderRadius: "24px",
        background: "var(--card-solid)",
        backgroundImage: "none",
        border: "1px solid var(--s10)",
        boxShadow: hovered
          ? "inset 0 1px 0 var(--s10), 0 18px 44px var(--sh40)"
          : "inset 0 1px 0 var(--s10), 0 14px 34px var(--sh40)",
        color: "var(--tx)",
        transition: "box-shadow 0.2s ease",
        ...sx,
      }}
    >
      <CardContent sx={{ height: "100%" }}>
        {title}
        {content}
      </CardContent>
    </Card>
  );
}

export default NewCard;
